/**
 * Delivery — orchestrator for /cannabis-delivery.
 * Fetches the cities list + live aggregate Google reviews, hands the rest
 * off to sub-section components under `/pages/delivery/`.
 */
import { useEffect, useState } from "react";
import SEOHead from "../components/SEOHead";
import { getCities } from "../lib/api";
import { useLiveAggregateReviews } from "../lib/useLiveReviews";

import DeliveryHero from "./delivery/DeliveryHero";
import DeliveryZipCheck from "./delivery/DeliveryZipCheck";
import DeliveryZones from "./delivery/DeliveryZones";
import DeliveryFooter from "./delivery/DeliveryFooter";

export default function Delivery() {
    const live = useLiveAggregateReviews([
        "queens-long-island",
        "staten-island",
    ]);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        getCities()
            .then((d) => setCities(d || []))
            .catch(() => {});
    }, []);

    return (
        <>
            <SEOHead
                title="Same-Day Weed Delivery · Queens, Long Island & Staten Island · ZenZest"
                description="NY-licensed cannabis delivery across Queens, Nassau Long Island, and all of Staten Island. Free delivery on every order, $100 minimum, most local orders within the hour. 21+."
                canonical="https://weeddispensarynearme.com/cannabis-delivery"
            />
            <DeliveryHero live={live} />
            <DeliveryZipCheck />
            <DeliveryZones />
            <DeliveryFooter cities={cities} />
        </>
    );
}
